import omit from "lodash/omit";
import { Filters, Value } from "PFTypes";

const isEmptyValue = (value: Value | undefined): boolean =>
  value === "" || value === null || value === undefined || (Array.isArray(value) && value.length === 0);

export const calcFiltersLength = ({ fields, strings, numbers, availability }: Filters<Value>): number =>
  Object.values({ ...omit(fields, "term"), ...strings, ...numbers, availability }).filter(
    (value) => !isEmptyValue(value)
  ).length;
